function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import classNames from '../../../_snowpack/pkg/classnames.js';
import { colors } from '../../css/index.js';
import LoadingIcon from './loading-icon.js';
const Wrapper = styled.div.withConfig({
  displayName: "loading__Wrapper",
  componentId: "yni08f-0"
})(["align-items:center;background:", ";display:flex;flex-direction:column;grid-area:content;height:100vh;justify-content:center;max-height:100%;width:100%;&.transparent{background:none;}"], colors.frost);
const Text = styled.div.withConfig({
  displayName: "loading__Text",
  componentId: "yni08f-1"
})(["color:", ";padding-top:25px;"], colors.frostbite);
const loadingTexts = ['Woah hold on there cowboy ...', 'Painting pixels ...', 'Scaling bananas ...', "We're testing your patience ...", 'Pressing random buttons ...', 'Spinning to win ...', 'Insert coin to Continue ...', 'Wait, how do I do this again?', 'Getting real dizzy now with this spinner', 'Oh dear. I wish was faster', 'Almost there...'];

function Loading(props) {
  const {
    transparent,
    children,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: classNames({
      transparent
    })
  }, rest, {
    "data-cypress": "big-loading-wrapper"
  }), /*#__PURE__*/React.createElement(LoadingIcon, null), /*#__PURE__*/React.createElement(Text, null, children || loadingTexts[Math.floor(Math.random() * loadingTexts.length)]));
}

export default Loading;